import { z } from 'zod';

export const tokenResultSchema = z.object({
  access_token: z.string(),
  expires_at: z.number(),
  refresh_expires_in: z.number(),
  refresh_token: z.string(),
  token_type: z.string(),
  id_token: z.string(),
  session_state: z.string(),
  scope: z.string(),
  ['not-before-policy']: z.number().optional(),
});

export type TokenResultBody = z.infer<typeof tokenResultSchema>;
